import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "nav"
};
const _hoisted_2 = {
  class: "nav-sub-menu"
};
const _hoisted_3 = {
  class: "nav-sub-menu-content"
};
const _hoisted_4 = {
  class: "title"
};
const _hoisted_5 = {
  class: "desc"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_menu_item = _resolveComponent("el-menu-item");
  const _component_ArrowRightBold = _resolveComponent("ArrowRightBold");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_sub_menu = _resolveComponent("el-sub-menu");
  const _component_el_menu = _resolveComponent("el-menu");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_menu, {
    "default-active": $data.defaultActive,
    "collapse-transition": "false",
    mode: "horizontal",
    onSelect: $options.handleMenuSelect
  }, {
    default: _withCtx(() => [_createVNode(_component_el_menu_item, {
      index: "/baas",
      class: "first-item"
    }, {
      default: _withCtx(() => [_createTextVNode("首页")]),
      _: 1
    }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.nav, (item, index) => {
      return _openBlock(), _createBlock(_component_el_sub_menu, {
        key: index,
        index: index + ''
      }, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(item.title), 1)]),
        default: _withCtx(() => [_withDirectives(_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (a, aIndex) => {
          return _openBlock(), _createBlock(_component_el_menu_item, {
            key: `${aIndex}0000`,
            index: a.path || a.url,
            disabled: a.disabled
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createTextVNode(_toDisplayString(a.title) + " ", 1), _createVNode(_component_el_icon, {
              size: "12px"
            }, {
              default: _withCtx(() => [_createVNode(_component_ArrowRightBold)]),
              _: 1
            })]), _createElementVNode("div", _hoisted_5, _toDisplayString(a.desc), 1)]),
            _: 2
          }, 1032, ["index", "disabled"]);
        }), 128))])], 512), [[_vShow, item.children && item.children.length > 0]])]),
        _: 2
      }, 1032, ["index"]);
    }), 128))]),
    _: 1
  }, 8, ["default-active", "onSelect"])]);
}